module.exports = __webpack_public_path__ + "static/media/renegades_joan_of_arc.f6712fc0.png";